<template lang="pug">
    #sitePage
        Navbar(v-if="hasAccess & !loadingProjects" tab="monitor" :siteId="siteId" :zoneId="zoneId" :site="site" :notifications="notifications" :scoreHelp="scoreHelp")
        SiteAlert(v-on:closeSiteAlert="closeSiteAlert" 
                    :id=0 
                    :trigger="newSensor" 
                    alertType="onboarding" 
                    name="calibration banner" 
                    message="Thank you for setting up your new devices. It is now connected, and you will see live data soon.")
        main(v-if="showPageSkeleton")
            v-container
                v-row.align-center.my-1
                    v-col(:cols="12" :md="6" :sm="12").align-center.d-flex
                        .hc-skel
                            .hc-skel-line.short
                    v-col(:cols="12" :md="6" :sm="12").d-flex.justify-end.align-center
                        .hc-skel
                            .hc-skel-line.mid
                v-row.site-header.no-flex
                    v-col.m12.l6.site-info
                        .hc-skel.site-skel-info
                            .hc-skel-line.site-skel-logo
                            .hc-skel-circle.site-skel-donut
                            .site-title
                                .hc-skel-line.mid
                                .hc-skel-line.short
                    v-col.m12.l6
                        .site-filter
                            .hc-skel.site-filter-ddl
                                .hc-skel-line.short
                                .hc-skel-line
                            .hc-skel.site-filter-ddl
                                .hc-skel-line.short
                                .hc-skel-line
                .site-skel-cards
                    .row(style="margin-top:10px;margin-bottom:10px;")
                        .col.s12
                            .card.material-table.aqcard.elevation-8.hc-skel
                                .aqcard-header.site-skel-card-header(style="padding-left:1.5rem;")
                                    .hc-skel-circle.site-skel-donut
                                    .hc-skel-line.mid
                                .aqcard-body
                                    .aqcard-bodycontent
                                        .aqcard-measurement.site-skel-tile(v-for="m in 16" :key="'zskel-tile-' + m")
                                            .aqcard-measurement-title-wrap
                                                .hc-skel-line.short
                                                .hc-skel-circle.site-skel-msmt-icon
                                            .hc-skel-line.mid.site-skel-msmt-value
                                            .hc-skel-line.short.site-skel-msmt-unit
                                            .hc-skel-line.site-skel-msmt-graph
        main(v-else-if="ready || site")
            v-btn.edit-fab(elevation="2" fab bottom color="var(--primary-alert)" fixed @click="$store.commit('toggleEditMode')" v-if="$store.state.user.role == 'admin' || $store.state.user.role == 'superAdmin'")
                v-icon(v-show="!$store.state.editMode") mdi-pencil
                v-icon(v-show="$store.state.editMode") mdi-close
            v-snackbar(v-model="snackbar" top right) {{snackMsg}}
                template(v-slot:action="{ attrs }")
                    v-icon.close-icon(text @click="snackbar=false") mdi-close				
            v-container(v-if="site && hasAccess")
                v-row.align-center.my-1
                        v-col(:cols="12" :md="6" :sm="12").align-center.d-flex
                            AppBreadcrumbs(label="Monitor" :site="site" :site-id="siteId")
                                span(v-for="(b,index) in zoneCrumbs" :key="'z-'+index")
                                    v-icon mdi-chevron-right
                                    span {{b.name}}
                        v-col(:cols="12" :md="6" :sm="12").d-flex.justify-end.align-center
                            v-switch(v-model="floorPlanView" v-if="floorPlanViewAvailable" style="max-height:33px").ma-0
                                template(v-slot:label)
                                    span(style="color:var(--app-primary-txt)") Floorplan View
                            .date-range(v-show="timePeriod != 'custom'" style="margin-left:63px") {{ dateRange }}
                v-row.site-header.no-flex
                    v-col.m12.l6.site-info
                        .site-image(:style='"background-image:url(" + (site.logo ? site.logo.url.replace("http", "https") : "") + ")"')
                        .site-progress(v-if="pageTitle.score && site.aqEnabled == true")
                            TooltipsSite(v-if="tooltipCount === 1 && site.aqEnabled == true" :id=0 name="site progress" position="bottom" arrowAlignment="left" message="Click this radial to see how the score is calculated." @next="advanceOnboardingTooltip")
                            a.modal-trigger(v-if="pageTitle.score" href="#modal-score-breakdown" style="color:var(--app-tertiary-txt)")
                                DonutIndicator(:key="pageTitle.id+'-pt-donut'" :id="pageTitle.id +'-scoreOA'" :cssClass="'main-donut'" :value="Math.round(pageTitle.score)" :size="60" v-if="site.aqEnabled !== false")
                            //- DonutIndicator(v-else :key="pageTitle.id+'-pt-donut'" :id="pageTitle.id +'-scoreOA'" :cssClass="'main-donut'" :value="Math.round(pageTitle.score)" :size="60")
                        .site-title(style="display:flex;flex-direction:column;")
                            router-link(:to="siteOverviewTo").siteLink {{pageTitle.title}}
                            .zone-halo-macs(v-if="showHaloMacsEnabled && zoneHaloMacs.length")
                                v-tooltip(top)
                                    template(v-slot:activator="{ on, attrs }")
                                        span.halo-mac-label(v-bind="attrs" v-on="on")
                                            v-icon(small color="var(--app-tertiary-txt)") mdi-access-point
                                            span {{ zoneHaloMacs[0] }}
                                    span Halo MAC address
                                span.halo-mac-more(v-if="zoneHaloMacs.length > 1" @click="openHaloMacsModal") and {{ zoneHaloMacs.length - 1 }} more
                            div(v-if="projectId&&projectId=='pwNeghwfDaNcSlOApelIYmA6'")
                                a.modal-trigger(href="#modal-airnow" style="color:var(--app-tertiary-txt)")
                                    span EPA AirNow AQI
                    v-col.m12.l6
                        .site-filter
                            .site-filter-ddl
                                .vuetify(data-app)
                                    HaqSelect(v-model="scope" :items="scopeZones" item-text="name" item-value="objectId" label="Zone" @change="loadZone" hide-details
                                        :menu-props="{ bottom: true, offsetY: true, closeOnClick: true, closeOnContentClick: true, }")
                            .site-filter-ddl
                                .vuetify(data-app)
                                    HaqSelect(v-model="timePeriod" :items="timePeriods" item-text="name" item-value="value" label="Time Period" hide-details disabled=(viewOnly?'true':null)
                                        :menu-props="{ bottom: true, offsetY: true, closeOnClick: true, closeOnContentClick: true, }")
                        .time-period(v-show="timePeriod === 'custom'")
                            .tp-input
                                label(for='dpStart') Starting Date
                                input.datepicker.start-date(ref='dpStart',name='dpStart',autocomplete='off',@change='setCustomTimePeriod')
                            .tp-input
                                label(for='dpEnd') Ending Date
                                input.datepicker.end-date(ref='dpEnd',name='dpEnd',autocomplete='off',@change='setCustomTimePeriod')
                TooltipsSite(v-if="tooltipCount === 0 && !zoneId" :id=1 name="zone button" position="top" arrowAlignment="center" message="Click this card to navigate into a zone." @next="advanceOnboardingTooltip")
                //- No cards?
                div(v-show="!floorPlanView").site-cards-wrap
                    .site-skel-cards(v-if="showCardSkeleton" :class="{ 'is-overlay': hasMountedCards }")
                        .row(style="margin-top:10px;margin-bottom:10px;")
                            .col.s12
                                .card.material-table.aqcard.elevation-8.hc-skel
                                    .aqcard-header.site-skel-card-header(style="padding-left:1.5rem;")
                                        .hc-skel-circle.site-skel-donut
                                        .hc-skel-line.mid
                                    .aqcard-body
                                        .aqcard-bodycontent
                                            .aqcard-measurement.site-skel-tile(v-for="m in 16" :key="'zskel-in-tile-' + m")
                                                .aqcard-measurement-title-wrap
                                                    .hc-skel-line.short
                                                    .hc-skel-circle.site-skel-msmt-icon
                                                .hc-skel-line.mid.site-skel-msmt-value
                                                .hc-skel-line.short.site-skel-msmt-unit
                                                .hc-skel-line.site-skel-msmt-graph
                    AqCard(:title="measurementsAF.name||'Air Freshness'", type="scoreAF", :score="measurementsAF.curScore", :measurements="measurementsAF.childMeasurements", v-if="measurementsAF&&measurementsAF.childMeasurements" :timePeriod="timePeriod" :tpCustomStart="tpCustomStart" :tpCustomEnd="tpCustomEnd" v-on:aqCardZoneChange="aqCardZoneChange" v-on:first-card-ready="endSiteLoading" :zoneTracker="zoneTracker" :measurementId="measurementsAF.uuid"
                        :measurementObjectId="measurementsAF.objectId")
                    AqCard(:title="measurementsAQ.name||'Air Quality'", type="scoreAF", :score="measurementsAQ.curScore", :measurements="measurementsAQ.childMeasurements", v-if="measurementsAQ&&measurementsAQ.childMeasurements" :timePeriod="timePeriod" :tpCustomStart="tpCustomStart" :tpCustomEnd="tpCustomEnd" v-on:aqCardZoneChange="aqCardZoneChange" v-on:first-card-ready="endSiteLoading" :zoneTracker="zoneTracker"
                        :measurementId="measurementsAQ.uuid" :measurementObjectId="measurementsAQ.objectId")
                    AqCard(:title="measurementsOW.name||'Environment Comfort'", type="scoreOW", :score="measurementsOW.curScore", :measurements="measurementsOW.childMeasurements", v-if="measurementsOW&&measurementsOW.childMeasurements" :timePeriod="timePeriod" :tpCustomStart="tpCustomStart" :tpCustomEnd="tpCustomEnd" v-on:aqCardZoneChange="aqCardZoneChange" v-on:first-card-ready="endSiteLoading" :zoneTracker="zoneTracker" :measurementId="measurementsOW.uuid"
                        :measurementObjectId="measurementsOW.objectId")
                    AqCard(:title="measurementsEQ.name||'Equipment Overview'", type="scoreEQ", :score="measurementsEQ.curScore", :measurements="measurementsEQ.childMeasurements", v-if="measurementsEQ&&measurementsEQ.childMeasurements" :timePeriod="timePeriod" :tpCustomStart="tpCustomStart" :tpCustomEnd="tpCustomEnd" v-on:aqCardZoneChange="aqCardZoneChange" v-on:first-card-ready="endSiteLoading" :zoneTracker="zoneTracker" :isEquipment="true"
                        :measurementObjectId="measurementsEQ.objectId" v-on:updateMeasurementText="measurementsEQ.name = $event")
                div(v-if="floorPlanViewAvailable" v-show="floorPlanView")
                    FloorPlanView
            v-container(v-else-if="!site && hasAccess")
                v-row
                    v-col
                        .empty-card There are no measurements for this site.
            v-container(v-else-if="!hasAccess")
                v-row
                    v-col
                        .empty-card Sorry, you do not have access to that project. Please contact your site administrator to request access.
        footer
            .container
                v-row
                    v-col.s12
                        span.powered(v-if="whitelabel") {{whitelabel}}
        ScoreBreakdownModal(:overallCurScore="pageTitle.score",:measurements="helpMeasurements" :key="helpMeasurements.length+1" v-if="pageTitle.score")
        AirNowModal(v-if="true")
        v-dialog(v-model="haloMacsModalOpen" max-width="400" content-class="haq-dialog")
            v-card.haq-dialog-card
                v-card-title.halo-macs-modal-title
                    v-icon(color="var(--app-tertiary-txt)" style="margin-right: 8px") mdi-access-point
                    span Halo MAC Addresses
                    v-spacer
                    v-btn(icon @click="haloMacsModalOpen = false")
                        v-icon mdi-close
                v-card-text
                    .halo-macs-list
                        .halo-mac-item(v-for="(mac, idx) in remainingHaloMacs" :key="mac")
                            span.halo-mac-value {{ mac }}
</template>
<script>
import Navbar from '@/components/Navbar.vue';
import SiteAlert from '@/components/SiteAlert.vue';
import DonutIndicator from '@/components/DonutIndicator.vue';
import AqCard from '@/components/AqCard.vue';
import moment from 'moment';
import {HTTPClient} from '../assets/js/http';
import ScoreBreakdownModal from '@/components/help/scoreBreakdown/ScoreBreakdownModal';
import AirNowModal from '@/components/AirNowModal';
import TooltipsSite from '@/components/NewUserOnboarding/TooltipsSite.vue'
import {wlData} from '../assets/js/constants';
let client = new HTTPClient();
import {useGetSite} from '../assets/js/hawken-query'
import FloorPlanView from './FloorPlan.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import HaqSelect from '@/components/form/HaqSelect.vue'

export default {
    name: 'Site',
    components: {
		Navbar,
		SiteAlert,
		DonutIndicator,
		AqCard,
		ScoreBreakdownModal,
        AirNowModal,
		TooltipsSite,
		FloorPlanView,
		AppBreadcrumbs,
		HaqSelect
    },
    data(){
        return {
			ready: false,
			siteLoading: true,
			projectId: this.$route.params.projectId,
			siteId: this.$route.params.siteId ? this.$route.params.siteId : this.$route.query.siteId,
			zoneId: this.$route.params.zoneId,
			hasAccess: true,
			loadingProjects: false,			
			site: null,
			zone: null,
			siteLogo: '',
			zones: null,
			measurementsAF: null,
			measurementsAQ: null,
			measurementsOW: null,
			measurementsEQ: null,
			scope: this.$route.params.zoneId ? this.$route.params.zoneId : 'overview',
			scopeZones: null,
            floorPlanViewAvailable: false,
            floorPlanView: false,
			timePeriod: 'week',
			timePeriods: [
				{'name':'Today','value':'day'},
				{'name':'This Week','value':'week'},
				{'name':'This Month','value':'month'},
				{'name':'Custom','value':'custom'}
			],
			tpCustomStart: moment().startOf('week').valueOf(),
			tpCustomEnd: moment().valueOf(),
			zoneCrumbs: [],
			pageTitle: {
				id: "",
				score: 0,
				title: "",
			},
			helpMeasurements: [],
			whitelabel: this.$store.state.project?.whitelabel?wlData.poweredByFooter:'',
			zoneTracker: {},
			tooltipCount: null,
			showSiteAlert: false,
			newSensor: false,
			notifications: {
				alerts: [],
				cssClass: null,				
			},
			scoreHelp: {
				overallCurScore: null,
				measurements: null,
				key: null,
			},
			activeDialog: null,
			snackbar: false,
			snackMsg: '',
			zoneHaloMacs: [],
			haloMacsModalOpen: false,
		};
	},
	methods: {
        closeModal() {
			this.activeDialog = null;
		},
		openHaloMacsModal() {
			this.haloMacsModalOpen = true;
		},
		startOnboardingTooltips(){
			let user = this.$store.state.user;
			let count = user.onboardingComplete?.tooltips ? Object.keys(user.onboardingComplete?.tooltips).length : 0;
			this.tooltipCount = count;
		},
		advanceOnboardingTooltip(){
			this.tooltipCount++;
		},
		openSiteAlert(measurements){
			let user = this.$store.state.user;
			let thirtyMin = moment().utc().subtract(30, 'minutes');
			let twoHours =  moment().utc().subtract(1, 'hours');
			let alertClosed = user.onboardingComplete?.alerts ? user.onboardingComplete.alerts[0].complete : 0;
			let recentlyClosed = (moment(alertClosed).utc()).isSameOrAfter(twoHours);
			let recentlyCreated = false;
			
			measurements.forEach(m => {
				if(m.type?.includes('score') && m.childMeasurements) {
					m.childMeasurements.forEach(cm => {
						let createdAt = (moment(cm.createdAt).utc());
						if (moment(createdAt).isSameOrAfter(thirtyMin))
							recentlyCreated = true;
					})
				}
				else {
					let createdAt = (moment(m.createdAt).utc());
					if (moment(createdAt).isSameOrAfter(thirtyMin))
						recentlyCreated = true;
				}
			});
			
			if(recentlyCreated && !recentlyClosed)
				this.newSensor = true;
			else
				this.newSensor = false;
		},
		closeSiteAlert(alertType){
			if(alertType == "onboarding")
				this.newSensor = false;
		},
		getAlertCssClass(){
			let criticalCount = 0;
			let warningCount = 0;
			this.notifications.alerts.forEach(a => {
				const t = (a.alertConfig && a.alertConfig.alertType) || '';
				if (t === 'critical')
					criticalCount++;
				else if(t === 'warning')
					warningCount++;
			})
			if (criticalCount)
				this.notifications.cssClass = 'msmt-alarm msmt-critical';
			else if(warningCount)
				this.notifications.cssClass = 'msmt-alarm msmt-warning';
		},
		loadZone(zoneId) {
			if(zoneId === "overview") {
				this.zoneId = null;
				let siteId = this.siteId;
				this.$router.push({name: 'Site', params: {projectId: this.projectId, siteId}});
			}
			else {
				this.zoneId = zoneId;
				this.$router.push({name: 'Zone', params: {projectId: this.projectId, zoneId}});
			}
		},
		aqCardZoneChange(zoneId){
			let zone = this.zones.find((el) => el.objectId == zoneId);
			if(!zone){
				zone = this.zones.find((el) => el.source && el.source.objectId == zoneId);
				if(!zone){
					throw `No zone found ${zoneId}`
				}
			}
			this.zoneId = zone.objectId;
			this.scope = zone.objectId;
			this.$router.push({name: 'Zone', params: {projectId: this.projectId, zoneId}});
		},
		setCustomTimePeriod() {

			let startVal = this.$refs.dpStart.value;
			let endVal = this.$refs.dpEnd.value
			
			if(!startVal || !endVal)
				return;

			let startISO = Date.parse(startVal);
			let endISO = Date.parse(endVal);
			let start = moment(startISO);
			let end = moment(endISO);

			if(start > end) {
				this.snackMsg = 'Starting date greater than the ending date';
				this.snackbar = true;
			}
			else if((end.diff(start,'day')) > 60) {
				this.snackMsg = 'Time period exceeds 60 days';
				this.snackbar = true;
			}
			else {
				this.tpCustomStart = startISO;
				this.tpCustomEnd = endISO;
				this.resetMeasurements();
				this.loadSite();
			}
        },
		setSensorCounts(zones,measurements){
            if(this.site.aqEnabled == false){
                measurements.forEach(m => {
                    m.sensorCount = m.childMeasurements?.length;
                })
                return measurements
            }
			zones.forEach(z => {
				if(z.name != "Overview") {
					measurements.forEach(cm => {
						if(z.id == cm.zone?.id) {
							let count = cm.childMeasurements?.length;
							let equipmentCount = z.scoreEQ?.childMeasurements?.length;
							if(equipmentCount)
								cm.sensorCount = count + equipmentCount;
							else
								cm.sensorCount = count;
						}
					})
				}
			})
			return measurements;
		},
		setMeasurements(zones,measurements){
			measurements.forEach(m => {
				if(m.type == 'scoreAF') {
					if(m.childMeasurements)
						this.sortMeasurements(m.childMeasurements);
					
					if(zones && m.childMeasurements)
						m.childMeasurements = this.setSensorCounts(zones, m.childMeasurements)

					this.measurementsAF = m;
					this.helpMeasurements.push(m);
				}
				if(m.type == 'scoreAQ') {
					if(m.childMeasurements)
						this.sortMeasurements(m.childMeasurements);

					if(zones && m.childMeasurements)
						m.childMeasurements = this.setSensorCounts(zones, m.childMeasurements)

					this.measurementsAQ = m;
					this.helpMeasurements.push(m);
				}
				if(m.type == 'scoreOW') {
					if(m.childMeasurements)
						this.sortMeasurements(m.childMeasurements);
					
					if(zones && m.childMeasurements)
						m.childMeasurements = this.setSensorCounts(zones, m.childMeasurements)

					this.measurementsOW = m;
					this.helpMeasurements.push(m);
				}
				if(m.type == 'scoreEQ') {
					if(m.childMeasurements)
						this.sortMeasurements(m.childMeasurements);

                    if(zones && m.childMeasurements)
						m.childMeasurements = this.setSensorCounts(zones, m.childMeasurements)
                        
					this.measurementsEQ = m;
					this.helpMeasurements.push(m);
				}
			});
		},
		sortAndSetChildMeasurements(childMeasurements, measurements){
			let cmf = measurements.filter((el) => childMeasurements.find((el2) => el2.objectId == el.objectId))
            //- console.log("cmf", cmf)
			cmf.forEach((el) => {
				if(el.childPoints?.length == 1){
					if(el.childPoints[0].functions?.length >= 1){
						el.writable = {
							endpoint: `/api/points/${el.childPoints[0].uuid}/runFunction`,
							function:  el.childPoints[0].functions
						}
					}
				}
			})
			return cmf.sort((a, b) => a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))
		},
		sortMeasurements(measurements){
			measurements.sort(function(a,b){ 
				// Safety check: if measurements don't have names (pointer objects), don't sort
				if (!a.name || !b.name) {
					return 0;
				}
				return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'})
			})
		},
		resetMeasurements() {
			this.projectId = this.$route.params.projectId || this.projectId;
			this.siteId = this.$route.params.siteId || this.$route.query.siteId || this.siteId;
			this.zoneId = this.$route.params.zoneId;
			this.measurementsAF = null;
			this.measurementsAQ = null;
			this.measurementsOW = null;
			this.measurementsEQ = null;
			this.helpMeasurements = [];
			this.zoneHaloMacs = [];
		},
		/**
		 * @description Recursive Zone Creator
		 * @param {Array} array,
		 * @param {String} zoneId
		 */
		createBreadcrumbs(array, zoneId) {
            let zone = this.zones.find((el) => el.objectId == zoneId || el.source?.objectId);
			array.unshift({
				name: zone.name,
				zoneId,
				siteId: this.siteId
			})
			if(zone.parent){
				return this.createBreadcrumbs(array, zone.parent.objectId)
			} else {
				return array;
			}
		},
		setBreadCrumbsAndTitle() {
			if(this.zoneId){
				this.zoneCrumbs = this.createBreadcrumbs([], this.zoneId);

				let zone = this.zones.find((el) => el.objectId == this.zoneId || el.source?.objectId == this.zoneId);
				this.pageTitle = {
					id: zone.objectId,
					score: zone.scoreOA?.curScore,
					title: zone.name,
				}
			} else {
				this.zoneCrumbs = [];
				this.pageTitle = {
					id: this.siteId,
					score: this.site.scoreOA?.curScore,
					title: this.site.name,
				}
			}
		},
		async fetchAlerts(){
			try {
				let results = await client.robustQuery(`/api/sites/${this.siteId}/alerts?isActive=true`);
				if(results.alerts.length > 0) {
					results.alerts.sort((a, b) => {
						const ta = (a.alertConfig && a.alertConfig.alertType) || '';
						const tb = (b.alertConfig && b.alertConfig.alertType) || '';
						if (ta === tb) return 0;
						return ta > tb ? 1 : -1;
					});
					this.notifications.alerts = results.alerts;
					this.getAlertCssClass();
				}
			} catch (error) {
				console.error(error);
			}
		},
		/**
		 * Hide card skeletons once the first inner measurement or zone tile can render.
		 */
		endSiteLoading() {
			this.siteLoading = false;
			this.ready = true;
		},
		/**
		 * Fetch devices for the site and extract Halo MAC addresses for the current zone.
		 */
		async loadZoneHaloMacs() {
			this.zoneHaloMacs = [];
			if (!this.zoneId || !this.siteId) return;
			try {
				const HALO_DATA_CONNECTION_ID = 'Hv5TYX1sDhfQfSRifvKccGey';
				const res = await client.robustQuery(`/api/sites/${this.siteId}/devices`);
				const devices = res.results || [];
				const macs = [];
				for (const d of devices) {
					const dcId = d.dataConnection?.objectId || d.dataConnection?.id;
					const zoneId = d.zone?.objectId || d.zone?.id;
					if (dcId !== HALO_DATA_CONNECTION_ID) continue;
					if (zoneId !== this.zoneId) continue;
					const mac = d.metadata?.mac || d.connectionMetadata?.mac || d.connectionMetadata?.id || '';
					if (mac && macs.indexOf(mac) < 0) {
						macs.push(mac);
					}
				}
				this.zoneHaloMacs = macs;
			} catch (error) {
				console.error('Failed to load zone Halo MACs', error);
			}
		},
		/**
		 * Load floor plans after cards are already showing.
		 */
		async loadFloors() {
			try {
				const { results: floors } = await client.robustQuery(`/api/sites/${this.siteId}/floors`);
				this.floors = floors;
				if(this.floors.length > 0){
					this.floorPlanViewAvailable = true;
				}
			} catch (error) {
				console.error(error);
			}
		},
		async loadSite() {
			try {
				this.siteLoading = true;
				let userAccess = false;
				if (this.$store.state.projects.length <= 0) {
					this.loadingProjects = true;
				} else {
					this.loadingProjects = false;
				}
				for (let p of this.$store.state.projects) {
					if (p.objectId == this.projectId) {
						userAccess = true;
						break;
					}
				}
				if (!userAccess) {
					this.hasAccess = false;
					if (!this.loadingProjects) {
						this.endSiteLoading();
					}
					return;
				} else {
					this.hasAccess = true;
				}
				if(this.zoneId){
					this.scope = this.zoneId;
				} else {
					this.scope = "overview";
				}

				const zonesPromise = client.robustQuery('/api/zones', {siteId: this.siteId, withMeasurements: true});
				const measurementsPromise = client.robustQuery('/api/measurements', {siteId: this.siteId, zoneId: this.zoneId});
				const sitePromise = useGetSite(this.siteId);

				const [zoneRes, site] = await Promise.all([zonesPromise, sitePromise]);
				this.site = site;
				this.ready = true;
				this.$store.commit("setSite", this.site);
				this.$store.commit('setProject', this.site.project);

				this.zones = zoneRes.results;
				this.scopeZones = zoneRes.results;
				this.scopeZones.unshift({'name':'Overview','objectId':'overview'});

				zoneRes.results.forEach(el => {
					this.zoneTracker[el.objectId] = el.name;
					if(el.source)
						this.zoneTracker[el.source.objectId] = el.name;
				})

				this.setBreadCrumbsAndTitle();

				const measurementsRes = await measurementsPromise;
				this.openSiteAlert(measurementsRes.results);
				this.setMeasurements(zoneRes.results,measurementsRes.results);
				const groups = [this.measurementsAF, this.measurementsAQ, this.measurementsOW, this.measurementsEQ];
				const hasInnerCards = groups.some((g) => g && g.childMeasurements && g.childMeasurements.length);
				if (!hasInnerCards) {
					this.endSiteLoading();
				}
				this.fetchAlerts();
				this.startOnboardingTooltips();
				this.loadFloors();
				this.loadZoneHaloMacs();

				this.scoreHelp = {
					overallCurScore: this.site.scoreOA?.curScore,
					measurements: this.helpMeasurements,
					key: this.helpMeasurements.length,
				}

				this.$nextTick(() => {
					let sn = document.querySelectorAll('.sidenav');
					window.M.Sidenav.init(sn);

					let sl = document.querySelectorAll('select');
					window.M.FormSelect.init(sl);

					let dp = document.querySelectorAll('.datepicker');
					let dpOptions = {
						minDate: new Date(this.site.firstDataDate || this.site.createdAt),
						maxDate: new Date(),
						autoClose: true,
						format: 'mmm d, yyyy',
					}
					window.M.Datepicker.init(dp, dpOptions);

					let dd = document.querySelectorAll('.dropdown-trigger');
					let dropOptions = { coverTrigger: false }
					window.M.Dropdown.init(dd,dropOptions);

					let mod = document.querySelectorAll('.modal');
                    window.M.Modal.init(mod, {dismissible: false});
					
				})
			} catch (error) {
                console.log("error", error);
				window.M.toast({html: 'Cannot Load Site'});
				this.endSiteLoading();
			}
		}
	},
	computed: {
		/**
		 * Full-page skeleton only before site chrome can render.
		 * @returns {boolean}
		 */
		showPageSkeleton() {
			return !this.site && this.siteLoading && (this.hasAccess || this.loadingProjects);
		},
		/**
		 * Card-area skeleton until the first inner measurement or zone tile is ready.
		 * @returns {boolean}
		 */
		showCardSkeleton() {
			return !!this.site && this.siteLoading && this.hasAccess;
		},
		/**
		 * True when AqCards are in the DOM so the skeleton can overlay them.
		 * @returns {boolean}
		 */
		hasMountedCards() {
			const groups = [this.measurementsAF, this.measurementsAQ, this.measurementsOW, this.measurementsEQ];
			return groups.some((g) => g && g.childMeasurements && g.childMeasurements.length);
		},
		/**
		 * Site overview route. Zone title clicks must use the site id, not the zone id.
		 * @returns {object}
		 */
		siteOverviewTo() {
			return { name: 'Site', params: { projectId: this.projectId, siteId: this.siteId } };
		},
		dateRange(){
			if(this.timePeriod && this.timePeriod!== "custom")
				return `${moment().startOf(this.timePeriod).format('MMM D')} - ${moment().format('MMM D, YYYY')}`
			else
				return ''
		},
		/**
		 * True when the project has Halo MAC display enabled.
		 * @returns {boolean}
		 */
		showHaloMacsEnabled() {
			return this.$store.state.project?.showHaloMacs === true;
		},
		/**
		 * Remaining MACs after the first (for the modal).
		 * @returns {string[]}
		 */
		remainingHaloMacs() {
			if (this.zoneHaloMacs.length <= 1) return [];
			return this.zoneHaloMacs.slice(1);
		}
	},
	mounted() {
		this.loadSite();
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		$route(to, from){
			this.resetMeasurements();
			this.loadSite();
		},
		'$store.state.projects': {
			handler() {
				this.resetMeasurements();
				this.loadSite();
			}
		}
	}
};
</script>
<style lang="sass" scoped>
	.no-flex
		display: block
	.v-app
		background: transparent
		.v-application--wrap
			display: block
	.modal-trigger
		&:hover
			.main-donut
				background: rgba(255, 255, 255, 0.1)
				-webkit-box-shadow: 0px 0px 10px 5px rgba(255, 255, 255, 0.2)
				box-shadow: 0px 0px 10px 5px rgba(255, 255, 255, 0.2)
				border-radius: 50%
	.siteLink
		color: var(--app-primary-txt)
		font-size: 28px
		line-height: inherit
		&:hover
			text-decoration: underline
	.zone-halo-macs
		margin-top: 4px
		display: flex
		align-items: center
		gap: 8px
		.halo-mac-label
			display: inline-flex
			align-items: center
			gap: 6px
			color: var(--app-tertiary-txt)
			font-size: 13px
			font-family: monospace
			cursor: default
			.v-icon
				margin-right: 2px
		.halo-mac-more
			color: var(--app-tertiary-txt)
			font-size: 13px
			cursor: pointer
			text-decoration: underline
			&:hover
				color: var(--app-primary-txt)
	.halo-macs-modal-title
		display: flex
		align-items: center
		padding-bottom: 8px !important
	.halo-macs-list
		.halo-mac-item
			padding: 8px 0
			border-bottom: 1px solid rgba(128, 128, 128, 0.2)
			&:last-child
				border-bottom: none
			.halo-mac-value
				font-family: monospace
				font-size: 14px
				color: var(--app-primary-txt)
	.date-range
		color: var(--app-tertiary-txt)
		text-align: right
		opacity: 1
	
	.edit-fab
		z-index: 10
		right: 340px !important
		bottom: 20px !important
		
		@media (max-width: 1024px)
			right: 290px !important

	.site-cards-wrap
		position: relative
	.site-skel-cards
		background: var(--app-primary-bg)
		&.is-overlay
			position: absolute
			left: 0
			right: 0
			top: 0
			z-index: 2
	.hc-skel
		pointer-events: none
		.hc-skel-line
			height: 10px
			border-radius: 6px
			background: linear-gradient(90deg, rgba(168, 174, 222, 0.14) 0%, rgba(168, 174, 222, 0.28) 45%, rgba(168, 174, 222, 0.14) 90%)
			background-size: 220% 100%
			animation: hc-skel-shimmer 1.15s ease-in-out infinite
			margin-bottom: 10px
			&.short
				width: 42%
			&.mid
				width: 68%
			&.center
				margin-left: auto
				margin-right: auto
		.hc-skel-circle
			width: 28px
			height: 28px
			border-radius: 50%
			margin: 0 auto 12px
			background: linear-gradient(90deg, rgba(168, 174, 222, 0.14) 0%, rgba(168, 174, 222, 0.28) 45%, rgba(168, 174, 222, 0.14) 90%)
			background-size: 220% 100%
			animation: hc-skel-shimmer 1.15s ease-in-out infinite
		&.hc-skel-block
			min-height: 140px
			padding: 18px
	.site-skel-info
		display: flex
		align-items: center
		width: 100%
		.site-skel-logo
			width: 120px
			height: 80px
			min-width: 120px
			border-radius: 20px
			margin-bottom: 0
			margin-right: 2rem
		.site-skel-donut
			width: 60px
			height: 60px
			margin: 0 1.5rem 0 0
		.site-title
			flex: 1
			.hc-skel-line:last-child
				margin-bottom: 0
	.site-skel-card-header
		display: flex !important
		align-items: center
		height: 80px
		max-height: 80px
		.site-skel-donut
			width: 40px
			height: 40px
			margin: 0 1rem 0 0
		.hc-skel-line
			margin-bottom: 0
	.site-skel-tile
		position: relative
		vertical-align: top
		.aqcard-measurement-title-wrap
			.hc-skel-line
				margin-bottom: 0
				width: 58%
			.site-skel-msmt-icon
				width: 28px
				height: 28px
				min-width: 28px
				margin: 0
		.site-skel-msmt-value
			width: 52%
			height: 26px
			margin-top: 10px
			margin-bottom: 8px
		.site-skel-msmt-unit
			width: 28%
			height: 10px
			margin-bottom: 0
		.site-skel-msmt-graph
			position: absolute
			left: 0
			right: 0
			bottom: 0
			width: 100%
			height: 72px
			margin: 0
			border-radius: 0 0 12px 12px

@keyframes hc-skel-shimmer
	0%
		background-position: 100% 0
	100%
		background-position: -100% 0
</style>